import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebase'; // Adjust the import according to your Firebase setup
import Skeleton from '@mui/material/Skeleton'; // Import Skeleton
import styles from './TrendingProduct.module.css'; // Import CSS Module
import { motion } from 'framer-motion'; // Import Framer Motion
import {  useCollection } from './GenericContext'; // Import useCollection hook
import { useNavigate } from 'react-router-dom';
import { useCart } from '../AddToCart/CartContext';

const TrendingProduct = () => {
  const navigate = useNavigate();
  const { data: product, isLoading } = useCollection(); // Use the generic context
  const [hovered, setHovered] = useState(false); // State for hover effect
  const [quantity, setQuantity] = useState(1); // State for quantity
  const { addToCart } = useCart();

  const handleProductClick = (id) => {
    navigate(`/product_detail/${id}`);
  };

  const handleBuyNow = () => {
    if (product) {
      addToCart({
        // id: product.id,
        // imageUrl: product.imageUrl,
        // title: product.title,
        // price: product.price,
        // name:product.name,
        ...product,
        quantity: quantity, // Use the selected quantity
      });
      navigate(`/shopnow`);
      // alert(`${product.title} added to cart!`);
      // alert(`${quantity} ${product.title}(s) added to cart!`); 
    }
  };

  if (isLoading) {
    return (
      <div className={styles.container}>
        {/* Image on the left side - Skeleton */}
        <div className={styles.imageContainer}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={400}
            className={styles.image} // Apply custom background color
          />
        </div>

        {/* Product details on the right side - Skeleton */}
        <div className={styles.detailsContainer}>
          <div>
            <Skeleton
              variant="text"
              width="60%"
              height={40}
              className={styles.title} // Apply custom background color
            />
            <Skeleton
              variant="text"
              width="80%"
              height={20}
              className={styles.text} // Apply custom background color
            />
          </div>

          {/* Buttons - Skeleton */}
          <div className={styles.flexColSpaceY4}>
            <Skeleton
              variant="rectangular"
              width="20%"
              height={40}
              className={`${styles.buyNowButton} ${styles.skeletonBackground}`} // Apply custom background color
            />
          </div>
        </div>
      </div>
    );
  }

  if (!product) {
    return <div>Product not found!</div>;
  }

  return (
    <motion.div
      className={styles.container}
      initial={{ opacity: 0, y: 50 }} // Initial animation state
      whileInView={{ opacity: 1, y: 0 }} // Animate when in view
      viewport={{ once: false  }} // Animate only once
      transition={{ duration: 0.5 }} // Animation duration
    >
      {/* Image on the left side */}
      <motion.div
        onClick={() => handleProductClick(product.id)}
        className={styles.imageContainer}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        initial={{ opacity: 0, x: -50 }} // Initial animation state
        whileInView={{ opacity: 1, x: 0 }} // Animate when in view
        viewport={{ once: false  }} // Animate only once
        transition={{ duration: 0.5, delay: 0.2 }} // Animation duration and delay
      >
        <motion.img
        className={styles.image}
        key={hovered ? "hovered" : "default"} // Ensure React re-renders for animation
        src={hovered ? product.imageUrl[1] : product.imageUrl[0]} 
        alt={product.title}
        initial={{ opacity: 0, scale: 0.95 }} 
        animate={{ opacity: 1, scale: 1 }} 
        exit={{ opacity: 0, scale: 0.95 }} 
        transition={{ duration: 0.5, ease: "easeInOut" }}
          // className={styles.image}
          // src={hovered ? product.imageUrl[1] : product.imageUrl[0]} // Change image on hover
          // alt={product.title }
          // whileHover={{ scale: 1.05 }} // Scale image on hover
          // transition={{ duration: 0.8 }}
        />
      </motion.div>

      {/* Product details on the right side */}
      <motion.div
        className={styles.detailsContainer}
        initial={{ opacity: 0, x: 50 }} // Initial animation state
        whileInView={{ opacity: 1, x: 0 }} // Animate when in view
        viewport={{ once: false  }} // Animate only once
        transition={{ duration: 0.5, delay: 0.4 }} // Animation duration and delay
      >
        <div>
          <motion.div
            className={styles.title}
            initial={{ opacity: 0 }} // Initial animation state
            whileInView={{ opacity: 1 }} // Animate when in view
            viewport={{ once: false  }} // Animate only once
            transition={{ duration: 0.5, delay: 0.6 }} // Animation duration and delay
          >
            {product.title}
          </motion.div>
          <motion.p
            className={styles.text}
            initial={{ opacity: 0 }} // Initial animation state
            whileInView={{ opacity: 1 }} // Animate when in view
            viewport={{ once: false  }} // Animate only once
            transition={{ duration: 0.5, delay: 0.8 }} // Animation duration and delay
          >
            {product.descriptionHeadingText[0]}
          </motion.p>
        </div>

        {/* Buttons */}
        <motion.div
          className={styles.flexColSpaceY4}
          initial={{ opacity: 0 }} // Initial animation state
          whileInView={{ opacity: 1 }} // Animate when in view
          viewport={{ once: false  }} // Animate only once
          transition={{ duration: 0.5, delay: 1 }} // Animation duration and delay
        >
          <motion.button 
          className={styles.buyNowButton}
          whileHover={{ scale: 1.05 }} // Hover effect
          whileTap={{ scale: 0.95 }} // Tap effect
          onClick={handleBuyNow}
          >
            BUY NOW
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default TrendingProduct;